import { api } from './client'
import type { TokenPair } from '../types'

export const authApi = {
  sendOTP: (target: string, provider: 'sms' | 'email' = 'sms'): Promise<{ otp_id: string; expires_in: number }> =>
    api.post('/v1/auth/send-otp', provider === 'email' ? { email: target } : { phone: target }),

  verifyOTP: (otpId: string, code: string, deviceName?: string): Promise<TokenPair & { is_new_user: boolean; user_id: string }> =>
    api.post('/v1/auth/verify-otp', { otp_id: otpId, code, device_name: deviceName ?? '' }),

  refresh: (refreshToken: string): Promise<TokenPair> =>
    api.post('/v1/auth/refresh', { refresh_token: refreshToken }),

  logout: () => api.post('/v1/auth/logout'),

  listSessions: () => api.get('/v1/auth/sessions'),

  revokeSession: (sessionId: string) => api.delete(`/v1/auth/sessions/${sessionId}`),

  enable2FA: (): Promise<{ totp_secret: string; qr_url: string }> =>
    api.post('/v1/auth/2fa/enable', {}),

  verify2FA: (code: string): Promise<void> =>
    api.post('/v1/auth/2fa/verify', { code }),
}
